import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';
import EmptyStateCard from 'modules/_shared/components/EmptyStates/EmptyStateCard';

const AnalyticsEmptyState: FC = () => {
  const { t } = useTranslate();
  return (
    <EmptyStateCard
      mainMessage={t('NoActivityFound')}
      infoMessage={t('NoActivityFoundDescription')}
    />
  );
};

export default AnalyticsEmptyState;
